import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Input, Button, InputLabel, FormControl, Switch } from "@material-ui/core";
import withStyles from "@material-ui/core/styles/withStyles";
import styles from '../../styles/app';

class AddApartment extends Component {

    state = {
        livingStatus: false,
        additionalExpenseStatus: false,
        sharingStatus: false,
        heatLossExpenseStatus: false
    };
    handleChangeStatus = name => event => {
        this.setState({ [name]: event.target.checked });
    };
    render() {
        const { classes } = this.props;

        return (
            <form encType="multipart/form-data" className={classes.form} onSubmit={(e) => { e.preventDefault(); this.props.onSubmitForm(e, this.state) }}>
                <input type="hidden" name="block" value={this.props.block._id} />
                <FormControl required fullWidth>
                    <InputLabel htmlFor="name">Daire Adı</InputLabel>
                    <Input
                        id="name"
                        name="name"
                        type="text"
                    />
                </FormControl>
                <FormControl required fullWidth>
                    <InputLabel htmlFor="floorStart">Daire m²</InputLabel>
                    <Input
                        id="squareMeters"
                        name="squareMeters"
                        type="number"
                    />
                </FormControl>
                <FormControl required fullWidth>
                    <InputLabel htmlFor="floorNumber">Kat Numarası</InputLabel>
                    <Input
                        id="floorNumber"
                        name="floorNumber"
                        type="number"
                    />
                </FormControl>
                <FormControl required fullWidth>
                    <InputLabel htmlFor="doorNumber">Kapı Numarası</InputLabel>
                    <Input
                        id="doorNumber"
                        name="doorNumber"
                        type="number"
                    />
                </FormControl>
                <FormControl required style={{ width: "20%" }}>
                    <InputLabel htmlFor="livingStatus">Doluluk Durumu</InputLabel>
                    <br />
                    <br />
                    <Switch checked={this.state.livingStatus} onChange={this.handleChangeStatus('livingStatus')} />
                </FormControl>
                <FormControl required style={{ width: "20%" }}>
                    <InputLabel htmlFor="additionalExpenseStatus">Ek Gider Alınma Durumu</InputLabel>
                    <br />
                    <br />
                    <Switch checked={this.state.additionalExpenseStatus} onChange={this.handleChangeStatus('additionalExpenseStatus')} />
                </FormControl>
                <FormControl required style={{ width: "20%" }}>
                    <InputLabel htmlFor="sharingStatus">Paylaşım Durumu</InputLabel>
                    <br />
                    <br />
                    <Switch checked={this.state.sharingStatus} onChange={this.handleChangeStatus('sharingStatus')} />
                </FormControl>
                <FormControl required style={{ width: "20%" }}>
                    <InputLabel htmlFor="heatLossExpenseStatus">Isı Kayıp Alınma Durumu</InputLabel>
                    <br />
                    <br />
                    <Switch checked={this.state.heatLossExpenseStatus} onChange={this.handleChangeStatus('heatLossExpenseStatus')} />
                </FormControl>
                <FormControl fullWidth>
                    <InputLabel htmlFor="description">Açıklama</InputLabel>
                    <Input
                        multiline
                        rows={4}
                        id="description"
                        name="description"
                        type="text"
                    />
                </FormControl>
                <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    color="primary"
                    className={classes.submit}
                >
                    DAİRE EKLE
                </Button>
            </form >
        )
    }
}

AddApartment.propTypes = {
    classes: PropTypes.object.isRequired,
};
export default withStyles(styles)(AddApartment);
